import { apiInstance } from 'api/utils';

export default {
  getAvailableCountryList: () =>
    apiInstance.request({
      method: 'GET',
      url: '/assistant/countries-languages/',
    }),
};
